export const genIntId = () => Math.floor(Math.random() * 1000000);
